var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { panelCard: !_vm.isMapChartType } },
    [
      _vm.isLoading
        ? [
            _c("ChartPreloader", {
              attrs: {
                classes: _vm.isMapChartType ? "mapPreloader panelCard" : "",
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isMapChartType
        ? _c("MapChart", {
            attrs: { "chart-title": _vm.chartTitle, loading: _vm.isLoading },
            on: {
              "set-category": function ($event) {
                return _vm.$emit("set-category", $event)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "map",
                  fn: function () {
                    return [
                      _c("div", {
                        ref: "chartWrapper",
                        staticClass: "highlightChart__highChart--map",
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1858899187
            ),
          })
        : _c("div", { staticClass: "highlightSection__chartBox" }, [
            _c(
              "div",
              {
                staticClass: "highlightChart__wrapper",
                class: { "opacity-0": !_vm.chart },
              },
              [
                _c("div", { staticClass: "padding-all-10" }, [
                  _c(
                    "h5",
                    {
                      staticClass:
                        "highlightChart__title hl-module text-color--dark-blue-gray",
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.chartTitle) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    ref: "chartWrapper",
                    staticClass: "highlightChart__highChart",
                  }),
                ]),
              ]
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }